module.exports = __webpack_public_path__ + "static/media/headshot.72448b69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/headshot.jpg
// module id = 275
// module chunks = 1